// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDSw4jW7y-X3_0H0M_EEqNLyiQMsWTwXQM",
  authDomain: "ai-depot-c4820.firebaseapp.com",
  projectId: "ai-depot-c4820",
  storageBucket: "ai-depot-c4820.firebasestorage.app",
  messagingSenderId: "630747270812",
  appId: "1:630747270812:web:65030e0af9115036572759",
  measurementId: "G-XJ4KBRYLP5"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage };
